import { render, staticRenderFns } from "./iconBadge.vue?vue&type=template&id=3722aea1&scoped=true&lang=pug"
import script from "./iconBadge.vue?vue&type=script&lang=ts"
export * from "./iconBadge.vue?vue&type=script&lang=ts"
import style0 from "./iconBadge.vue?vue&type=style&index=0&id=3722aea1&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3722aea1",
  null
  
)

export default component.exports